import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
// Store
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetVirtualTour } from './action/virtual-tour.actions';
// Service
import { QualityDocumentService } from '../../service/document-quality.service';
// Model
import { OrderCI_VIRTUALYOUR_STATE_PATH, VirtualTourModel } from './model/virtual-tour.model';
import { DOCUMENT_ATTACHMENT_CATEGORIES } from '../../model/quality.constant';

@State<VirtualTourModel>({
	name: OrderCI_VIRTUALYOUR_STATE_PATH,
	defaults: new VirtualTourModel()
})
@Injectable()
export class VirtualTourState {
	constructor(private qualityDocumentService: QualityDocumentService) {}

	/**
	 * Get Current virtual tour url Collection.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getVirtualTourCollection(state: VirtualTourModel): any[] {
		return state.data;
	}

	/**
	 *  set the virtual tour the current order
	 * @param ctx
	 * @param orderId
	 */
	@Action(SetVirtualTour)
	setVirtualTour(ctx: StateContext<VirtualTourModel>, { orderId }: SetVirtualTour): any {
		return this.qualityDocumentService
			.getOrderDocumentAttachments(orderId, DOCUMENT_ATTACHMENT_CATEGORIES.VirtualTour)
			.pipe(
				tap(result => {
					const { data } = result;
					ctx.patchState({
						data
					});
				})
			);
	}
}
